// Generated by purs version 0.11.7
"use strict";
var Control_Monad_Eff = require("../Control.Monad.Eff");
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./output/DOM/index.js
// module id = 73
// module chunks = 0